import { WebsiteProvider } from "features/Dealers/DealerSelect/state/types";

export const DEFAULT_WEBSITE_PROVIDER: WebsiteProvider = {
  id: "dealeron",
  displayName: "DealerOn",
  cmsURL:""
}

export const changeDocumentHead = (websiteProvider: WebsiteProvider) => {
  const link = document.createElement('link');
  const oldLink = document.getElementById('dynamic-favicon');
  link.id = 'dynamic-favicon';
  link.rel = 'shortcut icon';
  link.href = `/${websiteProvider.id}.ico`;
  if (oldLink) document.head.removeChild(oldLink);
  document.head.appendChild(link);

  const title = document.getElementsByTagName('title')[0];
  title.textContent = `${websiteProvider.displayName} Listings Manager`;  
}